export default __webpack_public_path__ + "static/media/icon-stands.d3c54648.svg";